import React from 'react';
import PropTypes from 'prop-types';
import TimelineLinks from 'images/Timeline@2x.jpg';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';

export default function TimelineLinksValuePropsModal({ onRequestClose }) {
  const formattedTitle = (
    <FormattedMessage
      id="ValueProps.timelinelinks.title"
      defaultMessage="Timeline Sharing"
      description="Title to name Timeline Links"
    />
  );

  const formattedDescription = (
    <FormattedMessage
      id="ValueProps.timelinelinks.description"
      defaultMessage="Send a project link that lets crew members and customers see photos as you add them."
      description="Description to explain what are Timeline Links"
    />
  );

  const formattedChecklistItems = [
    <FormattedMessage
      id="ValueProps.timelinelinks.valuePropA"
      defaultMessage="Show every job photo in chronological order"
      description="Value prop of Timeline Links feature"
    />,
    <FormattedMessage
      id="ValueProps.timelinelinks.valuePropB"
      defaultMessage="Generate a link to send via text or email"
      description="Value prop of Timeline Links feature"
    />,
    <FormattedMessage
      id="ValueProps.timelinelinks.valuePropC"
      defaultMessage="Share with anyone, even if they don't have the app"
      description="Value prop of Timeline Links feature"
    />,
  ];

  return (
    <ValuePropsModal
      title={formattedTitle}
      description={formattedDescription}
      checklistItems={formattedChecklistItems}
      image={TimelineLinks}
      onRequestClose={onRequestClose}
    />
  );
}

TimelineLinksValuePropsModal.propTypes = {
  onRequestClose: PropTypes.func,
};
